import Vue, { CreateElement } from '@src/vue'
import { Component, Prop } from 'vue-property-decorator'
import { ErrorScreen } from '@src/components/error-screen/error-screen'
import { getChartSeriesForScores } from '@src/util/functions'
import { Legend } from '@src/components/legend/legend'
import {
  APEX_CHARTS_TYPES,
  DEFAULT_CHART_HEIGHT, DEFAULT_CHART_WIDTH,
  DEFAULT_PRINT_CHART_HEIGHT, DEFAULT_PRINT_CHART_WIDTH,
  SCORE_BULLET_COLOR,
  SCORE_TYPES
} from '@src/util/constants'
import VueApexCharts from 'vue-apexcharts'

Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

@Component({
  computed: {
    selectedFilters () {
      return this.$store.state.statusScoreChartSelectedFilters
    }
  }
})
export class ScoreChart extends Vue {

  @Prop({ required: true })
  private scores: any

  @Prop({ required: true })
  private scoreCategories: any[]

  @Prop({ required: true })
  private getChartOptions: ([], bool, min, max, tickAmount, annotations, chartType) => any

  private selectedFilters: string[]

  constructor () {
    super()
  }

  filter (measurementType) {
    let filters = [ ...this.selectedFilters ]
    let index = filters.indexOf(measurementType)

    if (index >= 0) {
      filters.splice(index, 1)
    } else {
      filters.push(measurementType)
    }

    this.$store.dispatch('updateStatusScoreChartSelectedFilters', filters)
  }

  render (h: CreateElement) {
    return<div class='chart'>
        {this.renderScoresChart(h)}
        {this.renderScoresChart(h, true)}
      </div>
  }

  isScoreData () {
    return this.selectedFilters.length > 0 && this.scores.pixScores.length
  }

  hasScoreDataWithOnePoint () {
    return this.scores.pixScores.length === 1
      || this.scores.precisionScores.length === 1
      || this.scores.rangeScores.length === 1
      || this.scores.tempoScores.length === 1
  }

  renderScoresChart (h: CreateElement, printMode: boolean = false) {
    let chartOptions = this.getChartOptions(
      this.scoreCategories,
      printMode,
      0,
      100,
      undefined,
      [],
      this.hasScoreDataWithOnePoint() ? APEX_CHARTS_TYPES.SCATTER : APEX_CHARTS_TYPES.AREA
    )

    return <div class={printMode ? 'print-chart' : 'browser-chart'}>
      <Legend select={this.filter} items={
        SCORE_TYPES.map(item => {
          return {
            type: item,
            label: this.$t(`PAGE.MEMBERS.TRAINING.HISTORY.${item.toUpperCase()}`),
            color: SCORE_BULLET_COLOR[item],
            disabled: !this.selectedFilters.includes(item)
          }
        })
      } />
      { this.isScoreData() ?
        <apexchart
          id={printMode ? `score-print-chart` : `score-chart`}
          ref={printMode ? `score-print-chart` : `score-chart`}
          type={chartOptions.chart.type}
          height={printMode ? DEFAULT_PRINT_CHART_HEIGHT : DEFAULT_CHART_HEIGHT}
          width={printMode ? DEFAULT_PRINT_CHART_WIDTH : DEFAULT_CHART_WIDTH}
          options={chartOptions}
          series={getChartSeriesForScores(this.selectedFilters, this.scores, this)} />
      : <ErrorScreen icon='brand/empty-graph' message={this.$t('PAGE.MEMBERS.TRAINING.HISTORY.EMPTY_GRAPH_HISTORY')} />
      }
      </div>
  }
}
